<template>
  <div class="hero-section">
    <div class="hero-content">
      <div class="hero-badge">
        <span style="width: 8px; height: 8px; background: var(--primary); border-radius: 50%" />
        已支持小龙虾平台接入
      </div>
      <h1 class="hero-title">
        <span class="gradient-text">Feedax・可靠的数据服务供给中心</span><br />
      </h1>
      <h2 class="hero-tagline">织就行业数据肌理，支撑全域智能生长</h2>
      <p class="hero-subtitle">
        作为专业可靠的数据服务供给中心，平台聚焦多领域核心需求，精准面向OPC社区、xClaw、舆情分析团队、金融分析团队提供专业数据服务，通过深度整合、编织形成服务各行业的核心数据体系，为全场景的智能应用、AI
        生态提供底层数据支撑，助力智能技术与产业应用持续成长、长效发展。
      </p>
      <div class="hero-buttons">
        <button class="btn btn-primary btn-large" @click="copyInstallPrompt">
          一键复制安装提示词
        </button>
        <a href="#skills" class="btn btn-secondary btn-large">
          浏览技能
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, inject } from 'vue'
  import { ElMessage } from 'element-plus'
  import { useUserStore } from '@/store/modules/user'
  import { useSkillsStore } from '@/store/modules/skills'
  import { copyToClipboard } from '@/utils/clipboard'

  const userStore = useUserStore()
  const skillsStore = useSkillsStore()
  const loginUrl = inject('loginUrl')

  // 确保技能列表已加载
  onMounted(() => {
    if (skillsStore.list.length === 0) {
      skillsStore.fetchList()
    }
  })

  const copyInstallPrompt = async () => {
    if (!userStore.profile) {
      window.location.href = loginUrl
      return
    }

    // 确保 API Key 存在
    if (!userStore.apikey) {
      ElMessage.warning('请先生成 API Key')
      return
    }

    // 获取所有启用的技能的安装提示词
    const installScripts = skillsStore.list
      .filter((skill) => skill.enabled && skill.installScript)
      .map((skill) => skill.installScript)

    // 组合提示词：第一行 API Key，后面依次是各技能的安装提示词
    const promptText = [...installScripts, `API Key: ${userStore.apikey}`].join('\n')

    const success = await copyToClipboard(promptText)
    if (success) {
      ElMessage.success('已复制！发给你的龙虾即可')
    } else {
      ElMessage.error('复制失败，请手动复制')
    }
  }
</script>

<style scoped>
  .hero-section {
    position: relative;
    z-index: 10;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 120px 32px 80px;
  }

  .hero-content {
    max-width: 900px;
    text-align: center;
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.1);
    border: 1px solid rgba(99, 102, 241, 0.2);
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    color: var(--primary);
    margin-bottom: 32px;
    backdrop-filter: blur(10px);
  }

  [data-theme='dark'] .hero-badge {
    background: rgba(99, 102, 241, 0.15);
  }

  .hero-title {
    font-size: clamp(32px, 6vw, 56px);
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 20px;
    letter-spacing: -0.02em;
    color: var(--text-primary);
  }

  .hero-subtitle-gradient {
    font-size: 0.45em;
    font-weight: 600;
    background: linear-gradient(135deg, #64748b, #94a3b8);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .hero-subtitle {
    font-size: clamp(14px, 1.5vw, 16px);
    color: rgba(71, 85, 105, 0.7);
    max-width: 706px;
    margin: 0 auto 40px;
    line-height: 1.7;
  }

  [data-theme='dark'] .hero-subtitle {
    color: rgba(148, 163, 184, 0.7);
  }

  .hero-tagline {
    font-size: clamp(18px, 2.8vw, 28px);
    font-weight: 700;
    color: rgba(15, 23, 42, 0.8);
    margin-bottom: 20px;
    letter-spacing: 0.01em;
  }

  [data-theme='dark'] .hero-tagline {
    color: rgba(226, 232, 240, 0.9);
  }

  .hero-buttons {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    .hero-section {
      padding: 100px 20px 60px;
    }

    .hero-buttons {
      flex-direction: column;
      align-items: center;
    }
  }
</style>
